/**
 * Çizim hatası yakalayıcı.
 *
 * `apps/web/src/Hata.tsx`in kopyası. Kopya tutulmasının sebebi, bu
 * uygulamaların ortak bir bileşen paketi olmaması; paylaşılan tek şey
 * `@nirengi/engine` ve orası React bilmiyor. Dört kopya, dördünün de
 * React'e bağımlı bir ortak paket açmasından ucuz.
 *
 * NEDEN VAR
 *
 * Uygulamada hiç yoktu ve bunun bedeli bugün görüldü: davranış
 * bölümündeki hafta alanı temizlenince `haftaBasi` geçersiz tarihte
 * `toISOString()` çağırıp RangeError atıyordu. Hata ÇİZİM sırasında
 * olduğu için React bütün ağacı düşürüyor ve uygulayıcı danışan
 * dosyası yerine BEYAZ EKRAN görüyordu. Yaptığı tek şey bir tarih
 * alanını silmekti; ekranın neden gittiğini anlamasının hiçbir yolu
 * yoktu.
 *
 * O hata düzeltildi. Bu bileşen onun için değil, BİR SONRAKİ için:
 * aynı sınıftan bir hata bir daha olduğunda uygulayıcı beyaz ekran
 * değil, ne olduğunu söyleyen bir kutu görecek.
 *
 * HATA GİZLENMİYOR. Yakalayıcı, hatayı yutup "her şey yolunda"
 * demiyor: ne olduğunu yazıyor, konsola düşürüyor ve kullanıcıya
 * sayfayı yenileme yolu veriyor. Sessizce toparlanmak daha kötü
 * olurdu — bozuk bir ekranda çalışmaya devam eden uygulayıcı, veriye
 * yanlış şey yazabilir.
 *
 * KLİNİK VERİ EKRANA BASILMIYOR. Hata metni geliştirici için;
 * içinde danışan adı geçebilecek bir yığın izi gösterilmiyor.
 */

import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Durum {
  hata: Error | null
}

export class HataSiniri extends Component<{ children: ReactNode }, Durum> {
  override state: Durum = { hata: null }

  static getDerivedStateFromError(hata: Error): Durum {
    return { hata }
  }

  override componentDidCatch(hata: Error, bilgi: ErrorInfo): void {
    // Konsola düşsün: tarayıcı açıkken bakan biri yığın izini görebilsin
    console.error('Çizim hatası:', hata, bilgi.componentStack)
  }

  override render(): ReactNode {
    if (!this.state.hata) return this.props.children
    return (
      <div className="kart" style={{ margin: 24, maxWidth: 560 }}>
        {/* Çocuk ekranı: suçlayıcı olmayan, kısa bir metin. Teknik
            ayrıntı uygulayıcıya, çocuğa değil. */}
        <h2 style={{ marginTop: 0 }}>Bu çalışma açılamadı</h2>
        <p className="alt">
          Bir şeyler ters gitti. Sayfayı yenileyip tekrar dene; olmazsa
          öğretmenine ya da anne babana söyle.
        </p>
        <div className="dugmeler">
          <button className="birincil" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </button>
        </div>
      </div>
    )
  }
}
